module.exports = __webpack_public_path__ + "components/page-header/static/mountain-badge--dark-ee065d4f2cc0be6b420586ec9e755c79.svg";